import { Video } from "@/api";
import { Button } from "@/components";
import { DRAWER_SCHEDULE } from "@/const.ts";
import { useResponsiveness, useTranslate } from "@/providers/context";
import { Schedule } from "@/icons";
import { useAppProperties } from "@/hooks";

import { CalendarDrawer } from "./components/CalendarDrawer.tsx";

interface ScheduleButtonProps {
  video: Video;
}

export const ScheduleButton = ({ video }: ScheduleButtonProps) => {
  const { openDrawer, setOpenDrawer } = useResponsiveness();
  const { translate } = useTranslate();
  const { showCalendar } = useAppProperties();
  if (!showCalendar) {
    return null;
  }

  return (
    <>
      <Button
        data-testid="schedule-button"
        variant="secondary"
        onClick={() => setOpenDrawer(DRAWER_SCHEDULE)}
        size="s"
      >
        <Schedule className="mr-1" /> {translate("Schedule")}
      </Button>
      <CalendarDrawer
        video={video}
        open={openDrawer === DRAWER_SCHEDULE}
        setOpen={(open) => setOpenDrawer(open ? DRAWER_SCHEDULE : "")}
      />
    </>
  );
};
